import './main.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import ErrorBoundary from './components/ErrorBoundary';

/**
 * Mount React on every .ticket-block-root (one per block instance).
 */
function mountBlocks() {
  const roots = document.querySelectorAll('.ticket-block-root');
  roots.forEach((el) => {
    if (el.dataset.mounted === 'true') return;
    el.dataset.mounted = 'true';

    let blockData = {};
    try {
      const parent = el.closest('[data-ticket-block]');
      if (parent?.dataset.ticketBlock) {
        blockData = JSON.parse(parent.dataset.ticketBlock);
      }
    } catch (err) {
      console.error('[FCS-Ticket] Failed to parse block data:', err);
    }

    const root = createRoot(el);
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <App blockId={el.dataset.blockId} blockData={blockData} />
        </ErrorBoundary>
      </React.StrictMode>
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountBlocks);
} else {
  mountBlocks();
}

// Re-run when block preview re-renders in editor (ACF)
if (typeof window.acf !== 'undefined') {
  window.acf.addAction('render_block_preview/type=ticket', mountBlocks);
}
